// extracted by mini-css-extract-plugin
export default {"uploadImgWrap":"UploadImg__uploadImgWrap___RFjwV","spanCom":"UploadImg__spanCom___AVNhC","imgIconWrap":"UploadImg__imgIconWrap___HlSoR","imgText":"UploadImg__imgText___Pppxl"};